<template>
  <layout :tituloPagina="`Network | Routers | Edición | ${router.nombre} | Log`">
    <div class="row">
      <div class="col-md-12">       
        <div class="card">
          <div class="card-header justify-content-between d-flex align-items-center">
            <h4 class="card-title text-truncate w-100">
              Log del router {{ router.nombre }}
            </h4>
            <div class="me-2">
              <a href="#" onclick="return false;" @click="refrescarLogRouter()">
                <i class="mdi mdi-refresh text-success"></i>
              </a>
            </div>
            <div>
              <a href="#" onclick="return false;" @click="cerrar()">
                <i class="mdi mdi-close text-dark"></i>
              </a>
            </div>
          </div>
          <div class="card-body">
            <div id="scroll" class="table-responsive" style="height: 620px">
              <table class="table table-nowrap align-middle" id="tabla-log">
                <thead>
                  <tr>
                    <th style="width: 50px;"></th>
                    <th>Time</th>
                    <th>Topics</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="log in logs"
                    :key="log.id"
                    :class="{ 
                      'text-primary': contieneQue(log.topics, 'warning'),
                      'text-danger': contieneQue(log.topics)
                    }"
                  >
                    <td>
                      <strong>
                        {{ mikrotikIdToDecimal(log[".id"]) }}
                      </strong>
                    </td>
                    <td>{{ log.time }}</td>
                    <td>{{ formatearCadena(log.topics) }}</td>
                    <td>{{ formatoPalabra(log.message) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button class="btn btn-secondary" @click="atras()">
            <i class="mdi mdi-chevron-left"></i>
            Atrás
          </button>
          <button class="btn btn-success ms-1" @click="refrescarLogRouter()">
            <i class="mdi mdi-refresh"></i>
            Refrescar
          </button>
        </div>
      </div>
    </div>
    <br>
  </layout>
</template>

<script>
import Layout from "@/views/layouts/main"
import RouterSrv from '@/services/RouterSrv.js'

export default {
  name: 'LogRouter',
  components: { Layout },
  data() {
    return {
      id_router: null,
      router: { 
        id: null,
        nombre: ''
      },
      logs: [],
      primerCarga: true,
      
      mostrar_spinner: true,
      intervals: {
        actualizacion: null
      },
    }
  },
  created: function() {
    var self = this

    self.id_router = self.$route.params.id
    self.cargarRouter()

    self.intervals.actualizacion = setInterval(function() {
      self.mostrar_spinner = false
      self.refrescarLogRouter()
    }, 10000)
  },
  beforeUnmount() {
    clearInterval(this.intervals.actualizacion)
  },
  watch: {
    logs() {
      this.$nextTick(() => {
        setTimeout(() => {
          const contenedor = document.getElementById('scroll');
          if (!contenedor) return

          if (this.primerCarga) {
            // Scroll forzado en la primera carga
            contenedor.scrollTo({
              top: contenedor.scrollHeight,
              behavior: 'auto' // sin animación en la primera carga
            })
            this.primerCarga = false
          } else {
            // Scroll suave solo si el usuario está abajo
            const estaCasiAbajo = contenedor.scrollHeight - contenedor.scrollTop - contenedor.clientHeight < 50
            if (estaCasiAbajo) {
              contenedor.scrollTo({
                top: contenedor.scrollHeight,
                behavior: 'smooth'
              })
            }
          }
        }, 200)
      })
    }
  },
  methods: {
    atras: function() {
      this.$router.go(-1)
    },
    cerrar: function() {
      var self = this
      self.atras()
    },
    cargarRouter: function() {
      var self = this
      self.id_router = self.$route.params.id

      RouterSrv.routerJSON(self.id_router).then(response => {
        self.router = response.data

        self.refrescarLogRouter()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje) : ''
        console.log(error)
      })
    },

    contieneQue:function(cadena, contiene = 'error') {
      return cadena.toLowerCase().split(',').includes(contiene);
    },

    formatearCadena: function(cadena) {
      var self = this
      return cadena.split(',').map(p => self.formatoPalabra(p)).join(',');
    },
    formatoPalabra: function(palabra) {
      return palabra[0].toUpperCase() + palabra.slice(1);
    },

    mikrotikIdToDecimal: function(id) {
      if (typeof id === 'string' && id.startsWith('*')) {
        return parseInt(id.substring(1), 16);
      }
      return null;
    },

    refrescarLogRouter: function() {
      var self = this
      
      if(self.mostrar_spinner) iu.spinner.mostrar("#tabla-log")

      RouterSrv.logJSON(self.id_router).then(response => {
        self.logs = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar los log'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        if(self.mostrar_spinner) iu.spinner.ocultar("#tabla-log")
        self.mostrar_spinner = true
      })
    }
  }
}
</script>

<style scoped>
</style>